/* eslint-disable no-nested-ternary */
import React from 'react'
import { useTranslation } from 'lib/i18n'

import Spinner from 'components/Spinner/Spinner'

import styles from './ProfileReferralBlock.module.css'

function ProfileReferralBlock({ profileReferralCode, loading }) {
  const { t } = useTranslation()

  if (loading)
    return (
      <div className={styles.block}>
        <Spinner color="white" centered />
      </div>
    )

  return (
    <div className={styles.block} data-cy="profileReferralBlock">
      {profileReferralCode
        ? profileReferralCode.active
          ? t(
              'ProfileReferralBlock.activeHeading',
              'You have been invited by {{profileName}}',
              { profileName: profileReferralCode.profile?.name },
            )
          : t(
              'ProfileReferralBlock.inactiveHeading',
              'Your invite from {{profileName}} has expired – you can sign up below anyways or ask {{profileName}} for a new link',
              { profileName: profileReferralCode.profile?.name },
            )
        : t(
            'ProfileReferralBlock.notFound',
            'We could not find your invite, please check the link that you received.',
          )}
    </div>
  )
}

export default ProfileReferralBlock
